import{PiBy180 as o}from"../../constants.min.mjs";const t=t=>t*o,m=t=>t/o;export{t as degreesToRadians,m as radiansToDegrees};
//# sourceMappingURL=radiansDegreesConversion.min.mjs.map
